import React from "react"
import { styled } from "@mui/material"

import { useAppDispatch, useAppSelector } from "redux/hooks"
import { selectFetchStatus } from "redux/features/debt/debtSlice"
import { makeDownloadDebtContract } from "redux/features/debt/debtContractDownloadThunk"
import Button from "components/ui/Button"
import { colors } from "theme"

type Props = {
  debtId: string
  children: React.ReactNode
}

const DownloadComponent = ({ debtId, children, ...restProps }: Props) => {
  const dispatch = useAppDispatch()

  const fetchStatus = useAppSelector((state) => selectFetchStatus(state))

  const handleDownload = () => {
    if (!fetchStatus.isFetching) {
      dispatch(makeDownloadDebtContract({ debt_id: debtId })).then(
        ({ url }) => {
          window.open(url)
        },
      )
    }
  }

  return (
    <Download
      {...restProps}
      disabled={fetchStatus.isFetching}
      onClick={handleDownload}
    >
      {children}
    </Download>
  )
}

export default DownloadComponent

const Download = styled(Button)(({ theme }) => ({
  background: colors.lightPersianGreen,
  color: theme.palette.primary.main,
  borderRadius: "21px",
  fontSize: "0.875rem",
  textTransform: "inherit",
  height: "44px",
  padding: "0 20px",
  width: "100%",
}))
